<div class="account-container">
  <div class="div_tabs_account">


    <div id="div_your_account">
      <div style="width:26px ;height: 5px;align-items: center; padding-bottom: 5px; padding-right: 7px;">
        <div style="width:auto ;height: 3px; background-color: #2A3654;  "></div>
      </div>Your account<div
        style="padding-left: 7px; width:26px ;height: 5px;align-items: center; padding-bottom: 5px;">
        <div style="width:auto ;height: 3px; background-color: #2A3654;  "></div>
      </div>
    </div>

    <div *ngIf="valueLimitProjects" class="modal">
      <p>You have reached your project limit (10).</p>
    </div>

    <div class="account-sidebar">
      <ul style="margin-left: 20px;">
        <li [ngClass]="{'active': selectedTab === 'profile'}" (click)="selectTab('profile')">
          <img src="./assets/images/profile_icons/profile-icon.svg" style="margin-left: 15px;">Profile
        </li>
        <li [ngClass]="{'active': selectedTab === 'subscription'}" (click)="selectTab('subscription')">
          <img src="./assets/images/profile_icons/subscription-icon.svg" style="margin-left: 15px;">Subscription Plan
        </li>
        <li *ngIf="isAdmin === 'Admin'" [ngClass]="{'active': selectedTab === 'admin'}" (click)="selectTab('admin')">
          <img src="./assets/images/profile_icons/profile-icon.svg" style="margin-left: 15px;">Subscribers
        </li>
        <li *ngIf="tabOrganisation" [ngClass]="{'active': selectedTab === 'organisation'}"
          (click)="selectTab('organisation')">
          <img src="./assets/images/profile_icons/organisation-icon.svg" style="margin-left: 15px;">Organisation Manager
        </li>

        <!--  // DESCOMENTAR CODIGO PARA API USAGE -->
        <li *ngIf="isAPIUser"  [ngClass]="{'active': selectedTab === 'api-dashboard'}" (click)="selectTab('api-dashboard')">
          <img src="./assets/images/black_icons/api-dashboard-icon.svg" style="margin-left: 15px;">API Dashboard
        </li>


        
        <!-- DESCOMENTAR CODIGO PARA API FLOW -->
        <li *ngIf="isAdmin === 'Admin'" [ngClass]="{'active': selectedTab === 'api-usage'}"
          (click)="selectTab('api-usage')">
          <img src="./assets/images/black_icons/api-dashboard-icon.svg" style="margin-left: 15px;">API Usage
        </li>
        
      </ul>
    </div>



  </div>
  <div class="div_content_account">
    <div *ngIf="selectedTab === 'profile'">
      <div class="box-info-title">Your Account Information</div>
    </div>
    <div *ngIf="selectedTab === 'subscription'">
      <div class="box-info-title">Your Current Subscription Plan</div>
    </div>
    <div *ngIf="selectedTab === 'organisation'">
      <div class="box-info-title">This page lists the members of your Organisation</div>
    </div>

    <div *ngIf="selectedTab === 'api-dashboard'">
      <div class="box-info-title">Here you can see data about your API usage to manage it efficiently. Learn more about
        the API <span style="color: #EEA21A; cursor: pointer; text-decoration: underline;"><strong>Here.</strong></span>
      </div>
    </div>

    <div *ngIf="selectedTab === 'api-usage'">
      <div class="box-info-title">Here you can see data about your API usage to manage it efficiently. Learn more about
        the API <span style="color: #EEA21A; cursor: pointer; text-decoration: underline;"><strong>Here.</strong></span>
      </div>
    </div>

    <div *ngIf="selectedTab === 'admin'">
      <div class="box-info-title">Subscribers Overview</div>
    </div>

    <div class="account-content">
      <div *ngIf="selectedTab === 'profile'">
        <div class="edit-btn">
          <button *ngIf="!isEditing_Profile" (click)="toggleEdit()">
            <img src="./assets/images/profile_icons/edit-icon.svg">
            <u class="main-box-value-16-bold">Edit</u>
          </button>
          <div *ngIf="isEditing_Profile">
            <button (click)="cancelEdit()">
              <img src="./assets/images/yellow_icons/cancel-icon.svg">
              <u class="main-box-value-16-bold">Cancel</u>
            </button>
            <button (click)="saveValues()">
              <img src="./assets/images/yellow_icons/save-icon.svg">
              <u class="main-box-value-16-bold">Save</u>
            </button>
          </div>
        </div>
        <div class="account-details">
          <div class="detail-item" style="margin-bottom: 55px;">
            <label>Name</label>
            <p *ngIf="!isEditing_Profile" class="profile-text">{{name ? name : "--"}}</p>
            <input *ngIf="isEditing_Profile" [(ngModel)]="name" class="editable-input" />
          </div>
          <div class="detail-item" style="margin-bottom: 55px;">
            <label>Email</label>
            <p *ngIf="!isEditing_Profile" class="profile-text">{{email ? email : "--"}}</p>
            <input *ngIf="isEditing_Profile" [(ngModel)]="email" class="editable-input" />
          </div>
          <div class="detail-item" style="margin-bottom: 55px; position: relative;">
            <label *ngIf="!isEditing_Profile">Password</label>
            <label *ngIf="isEditing_Profile">Current Password</label>
            <p *ngIf="!isEditing_Profile" class="profile-text">{{getMaskedPassword()}}</p>
            <div class="input-container">
              <input *ngIf="isEditing_Profile" placeholder="Current Password"
                [type]="showPassword3 ? 'text' : 'password'" class="editable-input" />
              <img *ngIf="isEditing_Profile" class="eye-icon" src="./assets/images/eye-icon.svg"
                (click)="togglePasswordVisibilityCurrent()">
            </div>
          </div>
          <div class="detail-item" style="margin-bottom: 55px; position: relative;" *ngIf="isEditing_Profile">
            <label>New Password</label>
            <p *ngIf="!isEditing_Profile">{{getMaskedPassword()}}</p>
            <div class="input-container">
              <input *ngIf="isEditing_Profile" placeholder="New Password" [(ngModel)]="pass"
                [type]="showPassword ? 'text' : 'password'" class="editable-input" />
              <img *ngIf="isEditing_Profile" class="eye-icon" src="./assets/images/eye-icon.svg"
                (click)="togglePasswordVisibility()">
            </div>
          </div>
          <div class="detail-item" style="margin-bottom: 55px; position: relative;" *ngIf="isEditing_Profile">
            <label>Confirm New Password</label>
            <div class="input-container">
              <input [(ngModel)]="confirmPass" placeholder="Confirm New Password"
                [type]="showPassword2 ? 'text' : 'password'" class="editable-input" />
              <img class="eye-icon" src="./assets/images/eye-icon.svg" (click)="togglePasswordVisibility2()">
            </div>
            <p *ngIf="!passwordsMatch()" style="color: red;">Passwords do not match</p>
          </div>
        </div>
      </div>

      <div *ngIf="selectedTab === 'subscription'" style="padding-top: 10px; padding-bottom: 20px; padding-left: 4px;">

        <div *ngIf="loaderSubs" class="loader-container-subs">
          <div class="loader"></div>
        </div>
        <div class="box-cancel-subs" *ngIf="showCanceledMessage && !loaderSubs">
          <span class="main-box-title-14">Auto-renewal is now turned off. Your subscription will stay active until it ends. Changed your mind? Once your subscription period has expired you will be able to select a new subscription plan.</span>
         <!-- <button class="analysis-button" style="width: 250px; margin-bottom: 0px;" (click)="goToUpgrade()">
                  <span class="main-box-title-16" style="font-weight: 600;">
                    Renew Subscription
                </span></button> -->
        </div>
        <div class="account-info-header" *ngIf="!loaderSubs">
          <div class="main-box-value-16-bold">Subscription Plan</div>
          <div class="box-title-subs-plan">
            <div class="main-box-title-32" *ngIf="organisationInfo && !isRolLeader">
              You are a member of an organisation
            </div>

            <div class="main-box-title-32" *ngIf="organisationInfo && isRolLeader">
              {{ userObject.subscription.name ? userObject.subscription.name : "--" }}
            </div>

            <div class="main-box-title-32" *ngIf="!organisationInfo && !isRolLeader">
              {{ userObject.subscription.name ? userObject.subscription.name : "--" }}
            </div>

            <div class="box-button" *ngIf="
                  ((organisationInfo && isRolLeader) || (!organisationInfo && !isRolLeader))
                  && !showCanceledMessage
                  && !loaderSubs && userObject.subscription.name !== 'Admin'
                ">
               <button class="analysis-button" (click)="checkToUpgrade()">
                  <span class="main-box-title-16" style="font-weight: 600;" >
                    Upgrade Plan
                </span></button>

              <button class="cancel-btn" (click)="cancelSubscription()"
                *ngIf="userObject.subscription.name !== 'Free' && userObject.subscription.name !== 'Admin' && !isBasicApiCallsPlan">
                  <span><u class="main-box-value-16-bold" style="padding-bottom: 10px; color:#EEA21A;">Cancel Renewal</u></span>
              </button>
             
            </div>
          </div>
        </div>

        <div class="account-details" *ngIf="!loaderSubs">

          <div class="detail-item" style="margin-bottom: 25px;" *ngIf="!isFreePlan && !organisationInfo && !isRolLeader">
            <label>Payment</label>
            <div>
              <span>
                {{ subscriptionPaymentText }}
              </span>
              <br>
              <span *ngIf="payment && payment.start && payment.end">{{ payment_range_text }}</span>
            </div>
          </div>


          <div class="detail-item" style="margin-bottom: 25px;" *ngIf="!isFreePlan && organisationInfo && isRolLeader">
            <label>Payment</label>
            <div>
              <span>
                {{ subscriptionPaymentText }}
              </span>
              <br>
              <span *ngIf="payment_range_text">{{ payment_range_text }}</span>
            </div>
          </div>

          <div class="detail-item" style="margin-bottom: 25px;" *ngIf="!isFreePlan && (payment || name_payment_test || userObject.subscription.name !== 'Free')">
            <label>Payment Method</label>
            <div>
              <span *ngIf="name_payment_test">
                {{ name_payment_test || '-' }}
              </span>
              <br *ngIf="name_payment_test">
              <span *ngIf="name_payment_test">
                {{ userObject.user.email ? userObject.user.email : "--" }}
              </span>
              <span *ngIf="!name_payment_test">--</span>
            </div>
          </div>

          <div class="detail-item" *ngIf="!isApiCallsPlan">
            <label>Features</label>
            <ul>
              <li style="margin-bottom: 15px;">
                <img src="./assets/images/profile_icons/word-limit-icon.svg">Word limit <br>
                {{userObject.subscription.beneficios[0].word_count}} words
              </li>
              <li style="margin-bottom: 15px;" *ngIf="userObject.subscription.name !== 'Free'">
                <img src="./assets/images/profile_icons/extras-icon.svg">Extras <br> Can export data. Access to the
                English Vocabulary Profile, Academic Word List, and Scorecard.
              </li>
              <li style="margin-bottom: 15px;" *ngIf="userObject.subscription.name !== 'Free'">
                <img src="./assets/images/profile_icons/security-icon.svg">Security <br> Automatically deletes data from
                the server after 6 hours. Manual data clearing.
              </li>
            </ul>
          </div>
        </div>
        <!-- <button class="cancel-btn" *ngIf="userObject.subscription.name !== 'Free'" (click)="cancelsubscription()">
            Cancel subscription
          </button> -->
      </div>

      <div *ngIf="selectedTab === 'organisation'">
        <div class="table-container">
          <p *ngIf="isRolLeader && !loaderActive_organization">You are the organisation leader. You can add up to {{users_organization_limit}}
            members to this organisation.</p>
          <p *ngIf="!isRolLeader && !loaderActive_organization">You are a member of an organisation.</p>

          <div *ngIf="loaderActive_organization" class="loader-container-org">
            <div class="loader"></div>
          </div>
          <div id="overflow_table" *ngIf="!loaderActive_organization">
            <table mat-table [dataSource]="projects" class="mat-elevation-z8">
              <ng-container matColumnDef="name">
                <th *matHeaderCellDef> <span>Name</span> </th>
                <td mat-cell *matCellDef="let project" class="name-cell" style="text-align: left;"> {{project.name}}
                </td>
              </ng-container>

              <ng-container matColumnDef="wordCount">
                <th mat-header-cell *matHeaderCellDef><span>Email</span> </th>
                <td mat-cell *matCellDef="let project"> {{project.wordCount}} </td>
              </ng-container>

              <ng-container matColumnDef="sections">
                <th mat-header-cell *matHeaderCellDef> <span>Status</span> </th>
                <td mat-cell *matCellDef="let project"> {{project.sections}} </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let project" style="text-align: right;">
                  <button class="remove-btn" (click)="deleteMember(project)"
                    *ngIf="project.sections !== 'Leader' && isRolLeader"><img
                      src="./assets/images/delete-icon.svg"><u>Remove</u></button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>

          <ng-container *ngIf="isExpanded">
            <div id="div_add_email_member">
              <div class="main-box-value-16-bold">Add organisation member</div>
              <br>
              <div class="main-box-title-14">Organisation members share the organisation leader's benefits.</div>
              <div class="main-box-title-14">To add a member, have them first register a free account on Text Inspector.
                Then, enter their email addres in the field below and press <span style="font-weight: bold;">Add to
                  Organisation</span></div>
              <br>
              <input class="editable-input-org" placeholder="Email" (input)="onInputChange($event)">
              <br>
              <br>
              <div class="horizontal-box" id="div_buttons_add">
                <button mat-button color="primary" class="new-project-btn" (click)="addMember()"
                  [ngClass]="{'pseudo-disabled2': adding_member}" [disabled]="adding_member">Add To
                  Organisation</button>
                <button class="cancel-btn" (click)="toggleExpand()"><img
                    src="./assets/images/yellow_icons/close-icon.svg"> <span
                    style="font-size: 14px; padding-left: 5px;"><u>Cancel</u> </span></button>
              </div>
            </div>

          </ng-container>

        </div>
        <ng-container *ngIf="isExpanded2">
          <div id="div_button_add_new" *ngIf="!loaderActive_organization && isRolLeader">
            <button mat-button (click)="toggleExpand()" [ngClass]="{'pseudo-disabled': many_users_org}" color="primary"
              class="new-project-btn">
              Add New Member
            </button>
          </div>
        </ng-container>
        <br>
        <br>
        <br>
      </div>

      <div *ngIf="selectedTab === 'admin'">
        <div class="table-container-users">

          <div class="div_encabezado_general_users">

            <!-- Campo de selecc ión -->

            <div class="center-align">
              <span class="main-box-title-12" *ngIf="!loaderActive_subscribers">Search: </span>
              <div class="input-with-button" *ngIf="!loaderActive_subscribers">
                <input class="editable-input-subs" type="text" [(ngModel)]="searchTerm" (keyup.enter)="applyUserSearch()" />
                <!-- La X dentro del input -->
                <img *ngIf="searchTerm && searchTerm.trim() !== ''" src="./assets/images/black_icons/cancel-search.png"
                  class="input-clear-icon" (click)="seeAllUsers()" alt="clear" />
              </div>
            </div>

            <div style="padding-left: 15px; display: flex; align-items: anchor-center;"
              *ngIf="!loaderActive_subscribers">
              <button class="icon-button" (click)="exportToExcel()" *ngIf="!loaderActive_export">
                <span class="button-export">
                  <div>
                    <img src="../assets/images/export-con.svg" class="export-con">
                  </div>
                  <span>Export</span>
                </span>
              </button>
                <div *ngIf="loaderActive_export" class="div_loader_pag">
                <div id="div_loader_pag">
                  <div class="loader_pag"></div>
                </div>
              </div>
            </div>

          </div>

          <div *ngIf="loaderActive_subscribers" class="loader-container-users">
            <div class="loader"></div>
          </div>
          <div id="overflow_table" *ngIf="!loaderActive_subscribers">
            <div id="div_table_users">
              <table mat-table [dataSource]="paginatedUsers" class="mat-elevation-z8 size-table"
                style="padding-right: 12px !important;">

                 <ng-container matColumnDef="id" style="display: none;" hidden>
                  <th mat-header-cell *matHeaderCellDef style="text-align:left; cursor:pointer;display: none;"
                    (click)="sortUsers('id')">
                    <div style="display: flex;" [ngClass]="{'active-sort': sortColumn === 'id'}">
                      <div class="header-title">id</div>
                      <div class="arrow">⇅</div>
                    </div>

                  </th>
                  <td mat-cell *matCellDef="let users" class="name-cell" style="white-space: pre-line; display: none;"> {{users.id}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="user">
                  <th mat-header-cell *matHeaderCellDef style="text-align:left; cursor:pointer;"
                    (click)="sortUsers('user')">
                    <div style="display: flex;" [ngClass]="{'active-sort': sortColumn === 'user'}">
                      <div class="header-title">User</div>
                      <div class="arrow">⇅</div>
                    </div>

                  </th>
                  <td mat-cell *matCellDef="let users" class="name-cell" style="white-space: pre-line;"> {{users.user}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="typeSubs">
                  <th mat-header-cell *matHeaderCellDef style="text-align:left; cursor:pointer;"
                    (click)="sortUsers('typeSubs')">
                    <div style="display: flex;" [ngClass]="{'active-sort': sortColumn === 'typeSubs'}">
                      <div class="header-title">Subscription</div>
                      <div class="arrow">⇅</div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let users" class="name-cell" style="white-space: pre-line;">
                    {{users.typeSubs}} </td>
                </ng-container>

                <ng-container matColumnDef="start_d">
                  <th mat-header-cell *matHeaderCellDef style="text-align:left; cursor:pointer;"
                    (click)="sortUsers('start_d')">
                    <div style="display: flex;" [ngClass]="{'active-sort': sortColumn === 'start_d'}">
                      <div class="header-title">Start date</div>
                      <div class="arrow">⇅</div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let users" class="name-cell" style="white-space: pre-line;">
                    {{users.start_d}} </td>
                </ng-container>

                <ng-container matColumnDef="end_d">
                  <th mat-header-cell *matHeaderCellDef style="text-align:left; cursor:pointer;"
                    (click)="sortUsers('end_d')">
                    <div style="display: flex;" [ngClass]="{'active-sort': sortColumn === 'end_d'}">
                      <div class="header-title">End date</div>
                      <div class="arrow">⇅</div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let users" class="name-cell" style="white-space: pre-line;"> {{users.end_d}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="last_logged_on">
                  <th mat-header-cell *matHeaderCellDef style="text-align:left; cursor:pointer;"
                    (click)="sortUsers('last_logged_on')">
                    <div style="display: flex;" [ngClass]="{'active-sort': sortColumn === 'last_logged_on'}">
                      <div class="header-title">Last logged on</div>
                      <div class="arrow">⇅</div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let users" class="name-cell" style="white-space: pre-line;">
                    {{users.last_logged_on}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="organisation">
                  <th mat-header-cell *matHeaderCellDef style="text-align:left; cursor:pointer;"
                    (click)="sortUsers('organisation')">
                    <div style="display: flex;" [ngClass]="{'active-sort': sortColumn === 'organisation'}">
                      <div class="header-title">Organisation</div>
                      <div class="arrow">⇅</div>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let users" class="name-cell" style="white-space: pre-line;">
                    {{ users.organisation }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let users" class="bottoms-cell">
                    <button style="background-color: #F3F3F5; border: none;" (click)="editUser(users)">
                      <img class="img-logos btn-edit" src="./assets/images/edit-icon-yellow.svg">
                    </button>

                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsUsers"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsUsers;"></tr>
              </table>
            </div>
          </div>
          <div class="no-records" *ngIf="!loaderActive_subscribers && paginatedUsers.data.length === 0">
            No subscribers found
          </div>
          <!-- Paginador -->
          <div class="pagination-container" style="display: block;">
            <ul class="pagination" style="justify-content: center;"
              *ngIf="!loaderActive_subscribers && paginatedUsers.data.length != 0 && users.data.length > 10">
              <li><img style="padding-bottom: 8px;" (click)="prevPageUsers()"
                  src="./assets/images/dropdow-Icon-left.svg"></li>
              <li *ngIf="pagesUsers[0] > 1">
                <a (click)="goToPageUsers(1)">1</a>
              </li>

              <li *ngIf="pagesUsers[0] > 2">
                <span class="dots">...</span>
              </li>

              <li *ngFor="let page of pagesUsers" [ngClass]="{'active': page === currentPageUsers}">
                <a (click)="goToPageUsers(page)">{{ page }}</a>
              </li>

              <li *ngIf="pagesUsers[pagesUsers.length - 1] < totalPages - 1">
                <span class="dots">...</span>
              </li>

              <li *ngIf="pagesUsers[pagesUsers.length - 1] < totalPages">
                <a (click)="goToPageUsers(totalPages)">{{ totalPages }}</a>
              </li>
              <li><img style="padding-bottom: 8px;" (click)="nextPageUsers()"
                  src="./assets/images/dropdow-Icon-right.svg"></li>
            </ul>

            <div *ngIf="!loaderActive_subscribers" style="
                  font-size: 14px;
                  color: #EEA21A;
                  font-weight: 600; width: 100%;
                  text-align: center;
                ">
              {{ users.data.length }} Subscribers
            </div>
          </div>


        </div>

      </div>

      <div *ngIf="selectedTab === 'api-dashboard'" class="principal_api_dash" [style.min-height]="minHeight">


        <div class="table-container-users-dash">

          <!-- Encabezado con plan -->
          <div class="div_encabezado_general_users">
            <div class="api-dashboard-plan-summary">
              <p class="main-box-value-16 api-dashboard-plan-line">
                <span class="api-dashboard-plan-label">Current plan: </span>
                <strong><span class="api-dashboard-plan-name">{{ currentSubscriptionName }}</span></strong>
              </p>

              <button *ngIf="!showCanceledMessage" type="button" class="api-dashboard-upgrade-link"
                (click)="checkToUpgrade()">
                Upgrade Your Plan
              </button>
            </div>

            <div class="api-dashboard-actions">
              <div><span style="font-size: 16px;"><strong>{{ActualMonth}}</strong></span></div>
              <button class="api-dashboard-refresh-btn" type="button" (click)="refreshApiDashboard()"
                [disabled]="loaderActive || loaderActive2 || loaderActive3" matTooltip="Refresh data"
                aria-label="Refresh dashboard data">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>

          <!-- Caja de estadísticas -->
          <div class="div_api_doc">

            <div class="account-content-api">
              <p class="box-info-title-api">API Usage</p>

              <div *ngIf="loaderActive" class="loader-container">
                <div class="loader"></div>
              </div>

              <div class="div_api" *ngIf="!loaderActive">

                <!-- Porcentaje en círculo -->
                <div class="spinner-container">
                  <div class="progress-circle" [attr.data-percentage]="usagePercentage ?? 0">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                      <path class="circle-bg"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                      <path class="circle"
                        [attr.stroke-dasharray]="usagePercentage > 0 ? usagePercentage + ', 100' : '0, 100'"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                    </svg>
                  </div>
                  <div class="spinner-text">
                    <ng-container *ngIf="usagePercentage < 10">
                      0{{ usagePercentage }}<span class="percentage">%</span><span class="invisible-zeros">0</span>
                    </ng-container>
                    <ng-container *ngIf="usagePercentage >= 10">
                      {{ usagePercentage }}<span class="percentage">%</span>
                    </ng-container>
                  </div>



                </div>
                <div class="div_api2">
                  <div>
                    <p><strong>Monthly Call Allowance</strong><br>{{ apiCallsMadeT }}</p>
                  </div>

                  <!-- Texto informativo -->
                  <div>
                    <p>
                      <span class="color-circle" style="background-color: #8A268C;"></span>
                      <strong>API Calls Made</strong>
                      <br>
                      <span style="margin-left: 16px;"> {{ apiCallsMade }} ({{ usagePercentage }}%) </span>
                    </p>

                    <p>
                      <span class="color-circle" style="background-color: #73767D;"></span>
                      <strong>Unused API Calls</strong>
                      <br>
                      <span style="margin-left: 16px;"> {{ unusedApiCalls }} ({{ 100 - usagePercentage }}%) </span>

                    </p>
                  </div>

                </div>
              </div>
            </div>

            <div class="account-content-api-1-2">
              <p class="box-info-title-api" style="margin-bottom: 24px;">Documents Processed</p>

              <div *ngIf="loaderActive" class="loader-container">
                <div class="loader"></div>
              </div>

              <div *ngIf="!loaderActive" class="total_doc">
                <span style="font-size: 32px; font-weight: 200; ">
                  {{ totalDocuments }}
                </span>
                <span class="subtitle">
                  <strong>Total Documents</strong>
                </span>
              </div>

              <div *ngIf="!loaderActive" class="daily_ave">
                <span style="font-size: 32px; font-weight: 200; ">
                  {{ dailyAverage }}
                </span>
                <span class="subtitle">
                  <strong>Daily Average</strong>
                </span>
              </div>
            </div>
          </div>

          <!-- Gráfica -->
          <div class="account-content-api2">
            <div class="div_encabezado_hourly">

              <div class="box-info-title-api">Hourly Usage <span class="gmt_size">({{ apiTimeZoneLabel }})</span></div>


              <div style="width: auto; display: flex; justify-content: right; margin-bottom: 20px;">
                <mat-form-field appearance="outline" class="date-range-field2 compact-field" (click)="toggleCalendar2()"
                  (touch)="toggleCalendar2()" [ngClass]="{'expanded': calendarOpen2}">
                  <span matTooltip="Seleccionar Fecha" style="cursor: pointer;" #trigger2="cdkOverlayOrigin"
                    cdkOverlayOrigin>
                    <span class="formatted-text" *ngIf="DateText2 !== 'Seleccionar Fecha'">
                      {{ DateText2 }}<mat-icon class="expand-icon2" style="order:3;margin-left: 10px !important">expand_more</mat-icon>
                    </span>
                  </span>

                  <!-- Input oculto -->
                  <input matInput class="hidden-input">

                </mat-form-field>
              </div>

              <!-- Overlay flotante -->
              <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger2"
                [cdkConnectedOverlayOpen]="calendarOpen2" [cdkConnectedOverlayHasBackdrop]="true"
                (backdropClick)="closeCalendar2()" [cdkConnectedOverlayPositions]="overlayPositions"
                cdkConnectedOverlayPanelClass="calendar2-overlay">

                <div class="calendar2">
                  <mat-calendar [(selected)]="selectedDate" (selectedChange)="onDateSelected($event)"
                    class="calendar2_size">
                  </mat-calendar>
                </div>
              </ng-template>


            </div>

            <!-- scroll horizontal opcional -->
            <div *ngIf="loaderActive3" class="loader-container">
              <div class="loader"></div>
            </div>


            <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive3">
              <div style="display: flex; align-items: center;">
                <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;">
                  Calls
                </p>
              </div>
              <div style="overflow-x: auto; position: relative; width: 100%;" #scrollContainer2 (scroll)="onScroll2()">
                <div class="graficas3" style="position: relative;">

                  <!-- Mensaje centrado -->
                  <div *ngIf="chartData2.datasets[0].data.length === 0" class="noData_size">
                    There is no data
                  </div>

                  <!-- Canvas -->
                  <canvas *ngIf="showChartContainer" baseChart [data]="chartData2" [options]="chartOptions2"
                    [type]="'bar'">
                  </canvas>
                </div>
              </div>
            </div>


            <!-- <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive3">
            <div style="display: flex; align-items: center;">
              <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;"> Calls </p>
            </div>
            
            
            <div style="display: flex; width: 100%; height: 400px; /* Ajusta la altura según tu diseño (debe coincidir con el canvas) */">
              
             
              <div class="y-axis-fixed" style="width: 60px; /* Ajusta según el espacio de ticks (ej. para números hasta 100+) */ position: relative; background: transparent; /* Fondo transparente! */  border-left: none !important; border-right: 1px solid #9CA3AF; /* ¡Cambio: línea vertical a la DERECHA, color GRIS sutil (no negro intenso) */ overflow: hidden; height: 340px;">
                <div class="y-ticks-container" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: space-between; box-sizing: border-box;">
                  
                  <div *ngFor="let tick of yTicksCalls; let i = index" 
                      class="y-tick" 
                      [class.y-tick-last]="i === yTicksCalls.length - 1"
                      [style.height.%]="(100 / (yTicksCalls.length - 1))" 
                      style="display: flex; justify-content: flex-end; color: #2A3654; font-size: 12px; padding-top: 2px;">
                    {{ tick }}
                  </div>
                </div>
                
                <div *ngFor="let tick of yTicksCalls; let i = index" class="grid-line" [style.top.%]="(i * 100 / (yTicksCalls.length - 1))" style="position: absolute; left: 0; right: -10px; /* Extiende un poco a la derecha para alinear con gráfica */ height: 1px; background: #e0e0e0;"></div>
              </div>
              
              
              <div style="flex: 1; overflow-x: auto; overflow-y: hidden; position: relative; height: 440px;">
                <div class="graficas3" style="position: relative; min-width: 2400px; /* Ajusta: ~100px por label para 24 horas; fuerza scroll horizontal */">
                 
                  <div *ngIf="chartData2.datasets[0].data.length === 0" class="noData_size"> There is no data </div>
                  
                 
                  <canvas *ngIf="showChartContainer" baseChart 
                          [data]="chartData2" 
                          [options]="chartOptions2" 
                          [type]="'bar'"
                          style="margin-left: -1px; /* Ajuste fino para alinear con el borde del eje Y fijo */">
                  </canvas>
                </div>
              </div>
            </div>
          </div> -->


          </div>


          <div class="div_topCalendar">



            <p class="box-info-title-api" style=" margin-right: 14px; padding-top: 8px; margin-bottom: 0px;">Time period for the charts below</p>

            <div class="div_calendar">
              <mat-form-field appearance="outline" class="date-range-field compact-field" (click)="toggleCalendar()"
                (touch)="toggleCalendar()" [ngClass]="{'expanded': calendarOpen}">
                <span matTooltip="Seleccionar Rango de Fechas" style="cursor: pointer" #trigger="cdkOverlayOrigin"
                  cdkOverlayOrigin>
                  <span class="formatted-text" *ngIf="DateText !== 'Seleccionar Rango de Fechas'">
                    {{ DateText }} <mat-icon class="expand-icon" style="order:3;margin-left: 10px !important;">expand_more</mat-icon>
                  </span>

                </span>

                <!-- Inputs ocultos -->
                <mat-date-range-input [formGroup]="dateForm" [rangePicker]="picker" class="hidden-inputs">
                  <input matStartDate formControlName="start" placeholder="Fecha inicio" class="hidden-input">
                  <input matEndDate formControlName="end" placeholder="Fecha fin" class="hidden-input">
                </mat-date-range-input>
              </mat-form-field>

              <!-- Picker oculto -->
              <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
            </div>


          </div>

          <!-- Gráfica -->
          <div class="account-content-api3">
            <p class="box-info-title-api2">Daily Usage</p>

            <!-- scroll horizontal opcional -->

            <div *ngIf="loaderActive2" class="loader-container">
              <div class="loader"></div>
            </div>

            <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive2">
              <div style="display: flex; align-items: center;">
                <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;">
                  Calls
                </p>
              </div>
              <div style="overflow-x: auto; position: relative; width: 100%;" #scrollContainer (scroll)="onScroll()">
                <div class="graficas" #chartWrapper style="position: relative;">
                  <!-- Mensaje centrado -->
                  <div *ngIf="chartData.datasets[0].data.length === 0" class="noData_size">
                    There is no data
                  </div>

                  <!-- Canvas -->
                  <canvas *ngIf="showChartContainer" baseChart class="chart_size" [data]="chartData"
                    [options]="chartOptions" [type]="'bar'">
                  </canvas>
                </div>
              </div>

            </div>
          </div>


          <!-- Gráfica -->
          <div class="account-content-api2">
            <div class="div_encabezado_error">
              <p class="box-info-title-api2">Error Occurrences</p>

              <p class="box-info-title-api2" style="display: flex; align-items: center; gap: 8px;"
                *ngIf="!loaderActive2 && (chartData3.datasets[0].data.length && valido2)">
                <span style="display: flex; gap: 32px; align-items: center; font-size: 14px;">
                  <span style="display: flex; align-items: center; gap: 4px;">
                    <span
                      style="width: 12px; height: 12px; background-color: #8097FF; display: inline-block; border-radius: 2px;"></span>
                    4xx ({{ total404 }})
                  </span>
                  <span style="display: flex; align-items: center; gap: 4px;">
                    <span
                      style="width: 12px; height: 12px; background-color: #FF6673; display: inline-block; border-radius: 2px;"></span>
                    5xx ({{ total500 }})
                  </span>
                </span>
              </p>



            </div>

            <div *ngIf="loaderActive2" class="loader-container">
              <div class="loader"></div>
            </div>
            <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive2">
              <div style="display: flex; align-items: center;">
                <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;">
                  Occurrences
                </p>
              </div>
              <div style="overflow-x: auto; position: relative; width: 100%;" #scrollContainer3 (scroll)="onScroll3()">
                <div class="graficas" style="position: relative;">

                  <!-- Mensaje centrado -->
                  <div *ngIf="chartData3.datasets[0].data.length === 0 || !valido2" class="noData_size">
                    There is no data
                  </div>

                  <!-- Canvas -->
                  <canvas *ngIf="showChartContainer" baseChart class="chart_size" [data]="chartData3"
                    [options]="chartOptions3" [type]="'bar'">
                  </canvas>
                </div>
              </div>
            </div>


          </div>


          <div class="account-content-api_error">
            <p class="box-info-title-api2" style="margin-bottom: -10px;">Error Details</p>

            <div *ngIf="loaderActive2" class="loader-container" style="min-height: 200px;">
              <div class="loader"></div>
            </div>


            <div id="overflow_table_error">

              <div *ngIf="!loaderActive2 && (chartData3.datasets[0].data.length === 0 || !valido)" style="min-height: 200px; display: flex; align-items: center; justify-content: center;
                          font-weight: bold; color: #73767D; font-size: 18px;">
                There is no data
              </div>

              <table mat-table [dataSource]="paginatedProjects" class="mat-elevation-z8 custom-size-table"
                *ngIf="!loaderActive2 && (chartData3.datasets[0].data.length && valido)">
                <ng-container matColumnDef="date">
                  <th *matHeaderCellDef> <span>Date</span> </th>
                  <td mat-cell *matCellDef="let error" class="column_date" style="text-align: left;">{{ error.date }}</td>
                </ng-container>

                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef class="code-column"><span style="margin-left: 35px;">Code</span>
                  </th>
                  <td mat-cell *matCellDef="let error" class="code-column"> {{error.code}} </td>
                </ng-container>

                <ng-container matColumnDef="endpoint">
                  <th mat-header-cell *matHeaderCellDef><span>Endpoint</span></th>
                  <td mat-cell *matCellDef="let error">
                    <span class="method-box" [ngStyle]="{ 'background-color': getMethodColor(error.method) }">
                      {{ error.method }}
                    </span>
                    <span class="endpoint-text" matTooltip="{{ error.endpoint }}" matTooltipClass="custom-tooltip">
                      {{ error.endpoint }}
                    </span>
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns_Error"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns_Error;"></tr>
              </table>
            </div>

            <div class="pagination-container"
              *ngIf="!loaderActive2 && chartData3.datasets[0].data.length && Error_Details.data.length > itemsPerPage2">
              <ul class="pagination">
                <li><img style="padding-bottom: 8px;" (click)="prevPageProjects()"
                    src="./assets/images/dropdow-Icon-left.svg"></li>
                <li *ngFor="let page of pagesProjects" [ngClass]="{'active': page === currentPageProjects}">
                  <a href="#" (click)="goToPageProjects(page)">{{ page }}</a>
                </li>
                <li><img style="padding-bottom: 8px;" (click)="nextPageProjects()"
                    src="./assets/images/dropdow-Icon-right.svg"></li>
              </ul>
            </div>

          </div>

        </div>
      </div>

      <div *ngIf="selectedTab === 'api-usage'" class="principal_api_usage" [style.min-height]="minHeight2">
        <div class="div_encabezado_general_users">
          <p class="main-box-value-16-bold">Admin Users</p>

          <!-- Campo de selecc ión -->
          <div class="center-align">
            <span class="main-box-title-12" *ngIf="!apiUsage_loaderActive">Search: </span>
            <div class="input-with-button" *ngIf="!apiUsage_loaderActive">
              <input class="editable-input-subs" [(ngModel)]="searchTermApi" (keyup.enter)="applyUserSearchApi()" />
              <!-- La X dentro del input -->
              <img *ngIf="searchTermApi && searchTermApi.trim() !== ''"
                src="./assets/images/black_icons/cancel-search.png" class="input-clear-icon" (click)="seeAllUsersApi()"
                alt="clear" />
            </div>
          </div>
        </div>
        <div *ngIf="apiUsage_loaderActive" class="loader-container-subs-api">
          <div class="loader"></div>
        </div>
        <!-- Encabezado con plan -->
        <div class="div_encabezado_general_api" *ngIf="!apiUsage_loaderActive">
          <div id="overflow_table_api">
            <div id="div_table_users_api">
              <table mat-table [dataSource]="paginatedApiUsers" class="api-users-table">

                <ng-container matColumnDef="account_name">
                  <th mat-header-cell *matHeaderCellDef> Account name </th>
                  <td mat-cell *matCellDef="let data"> {{data.user_info?.name}} </td>
                </ng-container>

                <ng-container matColumnDef="account_email">
                  <th mat-header-cell *matHeaderCellDef> Account email </th>
                  <td mat-cell *matCellDef="let data"> {{data.user_info?.email}} </td>
                </ng-container>

                <ng-container matColumnDef="api_requests">
                  <th mat-header-cell *matHeaderCellDef> # API requests </th>
                  <td mat-cell *matCellDef="let data"> {{data.count}} </td>
                </ng-container>

                <ng-container matColumnDef="api_documents">
                  <th mat-header-cell *matHeaderCellDef> # Documents processed</th>
                  <td mat-cell *matCellDef="let data"> {{data.total_documentos_parseados}} </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns_api_usage_users"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns_api_usage_users;"
                  (click)="define_user_4more_info(row)" [class.selected_row]="more_info_api_usage === row">
                </tr>
              </table>

              <div class="no-records" *ngIf="!apiUsage_loaderActive && api_usage_data.length === 0">
                No users found
              </div>
            </div>

          </div>
          <!-- <p class="main-box-value-16">
              <span style="font-size: 18px;">Current plan: </span><strong><span style="font-size: 16px;">{{ currentSubscriptionName }} </span>  </strong>
              
              <span style="color: #EEA21A; cursor: pointer; text-decoration: underline; font-size: 16px;"><strong>Upgrade Your Plan</strong></span>
            </p> -->

          <!-- Campo de selección -->
          <!-- <div><span style="font-size: 16px;"><strong>{{ActualMonth}}</strong></span></div> -->
          <!-- Paginador -->

          <div class="pagination-container"
            *ngIf="!apiUsage_loaderActive && paginatedUsers.data.length != 0 && api_usage_data.length > 10">
            <ul class="pagination">
              <li><img style="padding-bottom: 8px;" (click)="prevPageUsersApi()"
                  src="./assets/images/dropdow-Icon-left.svg"></li>
              <li *ngFor="let page of pagesUsersApi" [ngClass]="{'active': page === currentPageUsersApi}">
                <a href="#" (click)="goToPageUsersApi(page)">{{ page }}</a>
              </li>
              <li><img style="padding-bottom: 8px;" (click)="nextPageUsersApi()"
                  src="./assets/images/dropdow-Icon-right.svg"></li>
            </ul>
          </div>
        </div>
        <div class="table-container-users">
          <div class="div_encabezado_general_users" *ngIf="more_info_api_usage">
            <p class="main-box-value-16">
              <span style="font-size: 18px;">Current plan: </span><strong><span style="font-size: 16px;">{{ currentSubscriptionName }}
                </span> </strong>

              <span *ngIf="!showCanceledMessage" (click)="checkToUpgrade()"
                style="color: #EEA21A; cursor: pointer; text-decoration: underline; font-size: 16px;"><strong>Upgrade
                  Your Plan</strong></span>
            </p>

            <!-- Campo de selección -->
            <div><span style="font-size: 16px;"><strong>{{ActualMonth}}</strong></span></div>
          </div>


          <!-- Caja de estadísticas -->
          <div class="div_api_doc" *ngIf="more_info_api_usage">

            <div class="account-content-api">
              <p class="box-info-title-api">API Usage</p>

              <div *ngIf="loaderActive" class="loader-container">
                <div class="loader"></div>
              </div>

              <div class="div_api" *ngIf="!loaderActive">


                <div class="spinner-container">
                  <div class="progress-circle" [attr.data-percentage]="usagePercentage ?? 0">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                      <path class="circle-bg"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                      <path class="circle"
                        [attr.stroke-dasharray]="usagePercentage > 0 ? usagePercentage + ', 100' : '0, 100'"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                    </svg>
                  </div>
                  <div class="spinner-text">
                    <ng-container *ngIf="usagePercentage < 10">
                      0{{ usagePercentage }}<span class="percentage">%</span><span class="invisible-zeros">0</span>
                    </ng-container>
                    <ng-container *ngIf="usagePercentage >= 10">
                      {{ usagePercentage }}<span class="percentage">%</span>
                    </ng-container>
                  </div>



                </div>
                <div class="div_api2">
                  <div>
                    <p><strong>Monthly Call Allowance</strong><br>{{ apiCallsMadeT }}</p>
                  </div>


                  <div>
                    <p>
                      <span class="color-circle" style="background-color: #8A268C;"></span>
                      <strong>API Calls Made</strong>
                      <br>
                      <span style="margin-left: 16px;"> {{ apiCallsMade }} ({{ usagePercentage }}%) </span>
                    </p>

                    <p>
                      <span class="color-circle" style="background-color: #73767D;"></span>
                      <strong>Unused API Calls</strong>
                      <br>
                      <span style="margin-left: 16px;"> {{ unusedApiCalls }} ({{ 100 - usagePercentage }}%) </span>

                    </p>
                  </div>

                </div>
              </div>
            </div>

            <div class="account-content-api-1-2">
              <p class="box-info-title-api" style="margin-bottom: 24px;">Documents Processed</p>

              <div *ngIf="loaderActive" class="loader-container">
                <div class="loader"></div>
              </div>

              <div *ngIf="!loaderActive" class="total_doc">
                <span style="font-size: 32px; font-weight: 200; ">
                  {{ totalDocuments }}
                </span>
                <span class="subtitle">
                  <strong>Total Documents</strong>
                </span>
              </div>

              <div *ngIf="!loaderActive" class="daily_ave">
                <span style="font-size: 32px; font-weight: 200; ">
                  {{ dailyAverage }}
                </span>
                <span class="subtitle">
                  <strong>Daily Average</strong>
                </span>
              </div>
            </div>
          </div>

          <!-- Gráfica -->
          <div class="account-content-api2" *ngIf="more_info_api_usage">
            <div class="div_encabezado_hourly">

              <div class="box-info-title-api">Hourly Usage <span class="gmt_size">({{ apiTimeZoneLabel }})</span></div>


              <div style="width: auto; display: flex; justify-content: right; margin-bottom: 20px;">
                <mat-form-field appearance="outline" class="date-range-field2 compact-field" (click)="toggleCalendar2()"
                  (touch)="toggleCalendar2()" [ngClass]="{'expanded': calendarOpen2}">
                  <span matTooltip="Seleccionar Fecha" style="cursor: pointer;" #trigger2="cdkOverlayOrigin"
                    cdkOverlayOrigin>
                    <span class="formatted-text" *ngIf="DateText2 !== 'Seleccionar Fecha'">
                      {{ DateText2 }}<mat-icon class="expand-icon2" style="order:3;margin-left: 10px !important">expand_more</mat-icon>
                    </span>
                  </span>

                  <input matInput class="hidden-input">

                </mat-form-field>
              </div>


              <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger2"
                [cdkConnectedOverlayOpen]="calendarOpen2" [cdkConnectedOverlayHasBackdrop]="true"
                (backdropClick)="closeCalendar2()" [cdkConnectedOverlayPositions]="overlayPositions"
                cdkConnectedOverlayPanelClass="calendar2-overlay">

                <div class="calendar2">
                  <mat-calendar [(selected)]="selectedDate" (selectedChange)="onDateSelected($event)"
                    class="calendar2_size">
                  </mat-calendar>
                </div>
              </ng-template>


            </div>


            <div *ngIf="loaderActive3" class="loader-container">
              <div class="loader"></div>
            </div>


            <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive3">
              <div style="display: flex; align-items: center;">
                <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;">
                  Calls
                </p>
              </div>
              <div style="overflow-x: auto; position: relative; width: 100%;" #scrollContainer2 (scroll)="onScroll2()">
                <div class="graficas3" style="position: relative;">


                  <div *ngIf="chartData2.datasets[0].data.length === 0" class="noData_size">
                    There is no data
                  </div>


                  <canvas *ngIf="showChartContainer" baseChart [data]="chartData2" [options]="chartOptions2"
                    [type]="'bar'">
                  </canvas>
                </div>
              </div>
            </div>


            <!-- <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive3">
            <div style="display: flex; align-items: center;">
              <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;"> Calls </p>
            </div>
            
            
            <div style="display: flex; width: 100%; height: 400px; /* Ajusta la altura según tu diseño (debe coincidir con el canvas) */">
              
             
              <div class="y-axis-fixed" style="width: 60px; /* Ajusta según el espacio de ticks (ej. para números hasta 100+) */ position: relative; background: transparent; /* Fondo transparente! */  border-left: none !important; border-right: 1px solid #9CA3AF; /* ¡Cambio: línea vertical a la DERECHA, color GRIS sutil (no negro intenso) */ overflow: hidden; height: 340px;">
                <div class="y-ticks-container" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: space-between; box-sizing: border-box;">
                  
                  <div *ngFor="let tick of yTicksCalls; let i = index" 
                      class="y-tick" 
                      [class.y-tick-last]="i === yTicksCalls.length - 1"
                      [style.height.%]="(100 / (yTicksCalls.length - 1))" 
                      style="display: flex; justify-content: flex-end; color: #2A3654; font-size: 12px; padding-top: 2px;">
                    {{ tick }}
                  </div>
                </div>
                
                <div *ngFor="let tick of yTicksCalls; let i = index" class="grid-line" [style.top.%]="(i * 100 / (yTicksCalls.length - 1))" style="position: absolute; left: 0; right: -10px; /* Extiende un poco a la derecha para alinear con gráfica */ height: 1px; background: #e0e0e0;"></div>
              </div>
              
              
              <div style="flex: 1; overflow-x: auto; overflow-y: hidden; position: relative; height: 440px;">
                <div class="graficas3" style="position: relative; min-width: 2400px; /* Ajusta: ~100px por label para 24 horas; fuerza scroll horizontal */">
                 
                  <div *ngIf="chartData2.datasets[0].data.length === 0" class="noData_size"> There is no data </div>
                  
                 
                  <canvas *ngIf="showChartContainer" baseChart 
                          [data]="chartData2" 
                          [options]="chartOptions2" 
                          [type]="'bar'"
                          style="margin-left: -1px; /* Ajuste fino para alinear con el borde del eje Y fijo */">
                  </canvas>
                </div>
              </div>
            </div>
          </div> -->


          </div>


          <div class="div_topCalendar" *ngIf="more_info_api_usage">
            <p class="box-info-title-api" style=" margin-right: 14px; padding-top: 8px; margin-bottom: 0px;">Time period
              for the charts below</p>

            <div class="div_calendar">
              <mat-form-field appearance="outline" class="date-range-field compact-field" (click)="toggleCalendar()"
                (touch)="toggleCalendar()" [ngClass]="{'expanded': calendarOpen}">
                <span matTooltip="Seleccionar Rango de Fechas" style="cursor: pointer" #trigger="cdkOverlayOrigin"
                  cdkOverlayOrigin>
                  <span class="formatted-text" *ngIf="DateText !== 'Seleccionar Rango de Fechas'">
                    {{ DateText }} <mat-icon class="expand-icon" style="order:3;margin-left: 10px !important">expand_more</mat-icon>
                  </span>
                </span>


                <mat-date-range-input [formGroup]="dateForm" [rangePicker]="picker" class="hidden-inputs">
                  <input matStartDate formControlName="start" placeholder="Fecha inicio" class="hidden-input">
                  <input matEndDate formControlName="end" placeholder="Fecha fin" class="hidden-input">
                </mat-date-range-input>
              </mat-form-field>


              <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
            </div>
          </div>

          <!-- Gráfica -->
          <div class="account-content-api3" *ngIf="more_info_api_usage">
            <p class="box-info-title-api2">Daily Usage</p>



            <div *ngIf="loaderActive2" class="loader-container">
              <div class="loader"></div>
            </div>

            <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive2">
              <div style="display: flex; align-items: center;">
                <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;">
                  Calls
                </p>
              </div>
              <div style="overflow-x: auto; position: relative; width: 100%;" #scrollContainer (scroll)="onScroll()">
                <div class="graficas" #chartWrapper style="position: relative;">

                  <div *ngIf="chartData.datasets[0].data.length === 0" class="noData_size">
                    There is no data
                  </div>


                  <canvas *ngIf="showChartContainer" baseChart class="chart_size" [data]="chartData"
                    [options]="chartOptions" [type]="'bar'">
                  </canvas>
                </div>
              </div>

            </div>
          </div>


          <!-- Gráfica -->
          <div class="account-content-api2" *ngIf="more_info_api_usage">
            <div class="div_encabezado_error">
              <p class="box-info-title-api2">Error Occurrences</p>

              <p class="box-info-title-api2" style="display: flex; align-items: center; gap: 8px;"
                *ngIf="!loaderActive2 && (chartData3.datasets[0].data.length && valido2)">
                <span style="display: flex; gap: 32px; align-items: center; font-size: 14px;">
                  <span style="display: flex; align-items: center; gap: 4px;">
                    <span
                      style="width: 12px; height: 12px; background-color: #8097FF; display: inline-block; border-radius: 2px;"></span>
                    4xx ({{ total404 }})
                  </span>
                  <span style="display: flex; align-items: center; gap: 4px;">
                    <span
                      style="width: 12px; height: 12px; background-color: #FF6673; display: inline-block; border-radius: 2px;"></span>
                    5xx ({{ total500 }})
                  </span>
                </span>
              </p>



            </div>

            <div *ngIf="loaderActive2" class="loader-container">
              <div class="loader"></div>
            </div>
            <div style="display: flex; align-items: stretch; gap: 0px; justify-content: center;" *ngIf="!loaderActive2">
              <div style="display: flex; align-items: center;">
                <p style="writing-mode: vertical-rl; transform: rotate(180deg); margin: 0; font-weight: bold;">
                  Occurrences
                </p>
              </div>
              <div style="overflow-x: auto; position: relative; width: 100%;" #scrollContainer3 (scroll)="onScroll3()">
                <div class="graficas" style="position: relative;">


                  <div *ngIf="chartData3.datasets[0].data.length === 0 || !valido2" class="noData_size">
                    There is no data
                  </div>


                  <canvas *ngIf="showChartContainer" baseChart class="chart_size" [data]="chartData3"
                    [options]="chartOptions3" [type]="'bar'">
                  </canvas>
                </div>
              </div>
            </div>


          </div>


          <div class="account-content-api_error" *ngIf="more_info_api_usage">
            <p class="box-info-title-api2" style="margin-bottom: -10px;">Error Details</p>

            <div *ngIf="loaderActive2" class="loader-container" style="min-height: 200px;">
              <div class="loader"></div>
            </div>


            <div id="overflow_table_error">

              <div *ngIf="!loaderActive2 && (chartData3.datasets[0].data.length === 0 || !valido)" style="min-height: 200px; display: flex; align-items: center; justify-content: center;
                          font-weight: bold; color: #73767D; font-size: 18px;">
                There is no data
              </div>

              <table mat-table [dataSource]="paginatedProjects" class="mat-elevation-z8 custom-size-table"
                *ngIf="!loaderActive2 && (chartData3.datasets[0].data.length && valido)">
                <ng-container matColumnDef="date">
                  <th *matHeaderCellDef> <span>Date</span> </th>
                  <td mat-cell *matCellDef="let error" class="column_date" style="text-align: left;">{{ error.date }}</td>
                </ng-container>

                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef class="code-column"><span style="margin-left: 35px;">Code</span>
                  </th>
                  <td mat-cell *matCellDef="let error" class="code-column"> {{error.code}} </td>
                </ng-container>

                <ng-container matColumnDef="endpoint">
                  <th mat-header-cell *matHeaderCellDef><span>Endpoint</span></th>
                  <td mat-cell *matCellDef="let error">
                    <span class="method-box" [ngStyle]="{ 'background-color': getMethodColor(error.method) }">
                      {{ error.method }}
                    </span>
                    <span class="endpoint-text" matTooltip="{{ error.endpoint }}" matTooltipClass="custom-tooltip">
                      {{ error.endpoint }}
                    </span>
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns_Error"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns_Error;"></tr>
              </table>
            </div>

            <div class="pagination-container"
              *ngIf="!loaderActive2 && chartData3.datasets[0].data.length && Error_Details.data.length > itemsPerPage2">
              <ul class="pagination">
                <li><img style="padding-bottom: 8px;" (click)="prevPageProjects()"
                    src="./assets/images/dropdow-Icon-left.svg"></li>
                <li *ngFor="let page of pagesProjects" [ngClass]="{'active': page === currentPageProjects}">
                  <a href="#" (click)="goToPageProjects(page)">{{ page }}</a>
                </li>
                <li><img style="padding-bottom: 8px;" (click)="nextPageProjects()"
                    src="./assets/images/dropdow-Icon-right.svg"></li>
              </ul>
            </div>

          </div>

        </div>
      </div>

    </div>
    <br>
    <br>
    <br>
    <br>
  </div>
</div>
